/**
* 介绍
*/
<template>
	<div>

		<!-- UUID 信息卡片 -->
		<div class="grid grid-cols-1 gap-6 mb-8">

			<div class="bg-white rounded-lg shadow-sm p-6">
				<h2 class="text-lg font-medium mb-4 flex items-center">
					<i class="fas fa-play text-blue-500 mr-2"></i>
					<!-- 服务 -->
					{{ $t('language000194') }}
					ID
				</h2>
				<div class="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
					<code class="text-blue-600 font-mono">0000fee7-0000-1000-8000-00805f9b34fb</code>
					<button class="text-gray-600 hover:text-blue-500 !rounded-button whitespace-nowrap"
						@click="copyToClipboard000('0000fee7-0000-1000-8000-00805f9b34fb')">
						<i class="fas fa-copy"></i>
						<span class="ml-1">
							<!-- 复制 -->
							{{ $t('language000195') }}
						</span>
					</button>
				</div>
			</div>

			<div class="bg-white rounded-lg shadow-sm p-6">
				<h2 class="text-lg font-medium mb-4 flex items-center">
					<i class="fas fa-broadcast-tower text-blue-500 mr-2"></i>
					<!-- 监听 -->
					{{ $t('language000196') }}
					UUID
				</h2>
				<div class="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
					<code class="text-blue-600 font-mono">000036f6-0000-1000-8000-00805f9b34fb</code>
					<button class="text-gray-600 hover:text-blue-500 !rounded-button whitespace-nowrap"
						@click="copyToClipboard000('000036f6-0000-1000-8000-00805f9b34fb')">
						<i class="fas fa-copy"></i>
						<span class="ml-1">
							<!-- 复制 -->
							{{ $t('language000195') }}
						</span>
					</button>
				</div>
			</div>

			<div class="bg-white rounded-lg shadow-sm p-6">
				<h2 class="text-lg font-medium mb-4 flex items-center">
					<i class="fas fa-edit text-blue-500 mr-2"></i>
					<!-- 写入 -->
					{{ $t('language000197') }}
					UUID
				</h2>
				<div class="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
					<code class="text-blue-600 font-mono">000036f5-0000-1000-8000-00805f9b34fb</code>
					<button class="text-gray-600 hover:text-blue-500 !rounded-button whitespace-nowrap"
						@click="copyToClipboard000('000036f5-0000-1000-8000-00805f9b34fb')">
						<i class="fas fa-copy"></i>
						<span class="ml-1">
							<!-- 复制 -->
							{{ $t('language000195') }}
						</span>
					</button>
				</div>
			</div>
		</div>


		<!-- Token 修改说明 -->
		<div class="bg-white rounded-lg shadow-sm p-6 mb-8">
			<h2 class="text-lg font-medium mb-4 flex items-center">
				<i class="fas fa-key text-blue-500 mr-2"></i>
				<!-- 设备 Token -->
				{{ $t('language000190') }}
			</h2>
			<div class="space-y-4">
				<div class="flex items-start" style="margin-top: 40px;">
					<div
						class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-500 font-medium">
						1</div>
					<div class="ml-4">
						<h3 class="font-medium mb-2">
							<!-- Token获取 -->
							{{ $t('language000198') }}
						</h3>
						<p class="text-gray-600">
							<!-- 建立蓝牙连接后，首先需要获取当前设备的Token用于身份验证 -->
							{{ $t('language000201') }}
						</p>
					</div>
				</div>
				<div class="flex items-start" style="margin-top: 40px;">
					<div
						class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-500 font-medium">
						2</div>
					<div class="ml-4">
						<h3 class="font-medium mb-2">
							<!-- Token更新机制 -->
							{{ $t('language000199') }}
						</h3>
						<p class="text-gray-600">
							<!-- 设备每次开机会进行Token更新 -->
							{{ $t('language000202') }}
						</p>
					</div>
				</div>
				<div class="flex items-start" style="margin-top: 40px;">
					<div
						class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-500 font-medium">
						3</div>
					<div class="ml-4">
						<h3 class="font-medium mb-2">
							<!-- Token作用 -->
							{{ $t('language000200') }}
						</h3>
						<p class="text-gray-600">
							<!-- 每次获取蓝牙命令需要携带Token进行身份验证 -->
							{{ $t('language000203') }}
						</p>
					</div>
				</div>
			</div>
		</div>



		<!-- 设备操作指引 -->
		<div class="bg-white rounded-lg shadow-sm p-6">
			<h2 class="text-lg font-medium mb-6 flex items-center">
				<i class="fas fa-lightbulb text-blue-500 mr-2"></i>
				<!-- 设备操作指引 -->
				{{ $t('language000204') }}
			</h2>
			<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
				<div class="bg-gray-50 rounded-lg p-6 text-center">
					<div class="w-16 h-16 bg-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center">
						<i class="fas fa-hand-paper text-white text-2xl"></i>
					</div>
					<h3 class="font-medium mb-2">{{ $t('language000205') }} 1</h3>
					<p class="text-gray-600">
						<!-- 长按设备按钮直至看到蓝色常亮 -->
						{{ $t('language000206') }}
					</p>
				</div>
				<div class="bg-gray-50 rounded-lg p-6 text-center">
					<div
						class="w-16 h-16 bg-green-500 rounded-full mx-auto mb-4 flex items-center justify-center animate-pulse">
						<i class="fas fa-lightbulb text-white text-2xl"></i>
					</div>
					<h3 class="font-medium mb-2">{{ $t('language000205') }} 2</h3>
					<p class="text-gray-600">
						<!-- 松开按钮后，设备指示灯将呈现绿色闪烁状态 -->
						{{ $t('language000207') }}
					</p>
				</div>
				<div class="bg-gray-50 rounded-lg p-6 text-center">
					<div class="w-16 h-16 bg-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center">
						<i class="fas fa-check text-white text-2xl"></i>
					</div>
					<h3 class="font-medium mb-2">{{ $t('language000205') }} 3</h3>
					<p class="text-gray-600">
						<!-- 监听成功后，设备指示灯将转为蓝色常亮状态 -->
						{{ $t('language000208') }}
					</p>
				</div>
			</div>
		</div>

		<!-- 注意事项 -->
		<div class="bg-yellow-50 border-l-4 border-yellow-400 p-4" style="margin-top: 30px;">
			<div class="flex">
				<div class="flex-shrink-0">
					<i class="fas fa-exclamation-triangle text-yellow-400"></i>
				</div>
				<div class="ml-3">
					<h3 class="text-sm font-medium text-yellow-800">
						<!-- 注意事项 -->
						{{ $t('language000209') }}
					</h3>
					<p class="mt-2 text-sm text-yellow-700">
						<!-- 如果操作过程中遇到问题，请确保设备电量充足，并且与手机保持在有效连接距离内（建议不超过 10 米） -->
						{{ $t('language000210') }}
					</p>
				</div>
			</div>
		</div>

		<!-- 项目地址 -->
		<div class=" bg-gray-50 py-12">
			<div class="mx-auto">
				<div class="bg-white rounded-lg shadow-sm p-8">
					<h1 class="text-2xl font-bold mb-8 text-gray-800">GitHub</h1>

					<div class="bg-gray-50 rounded-lg border border-gray-200 p-6 mb-6">
						<h2 class="text-lg font-medium text-gray-700 mb-4">Android</h2>
						<div class="flex items-center space-x-4 bg-gray-100 rounded-lg p-4 group relative"
							:class="{'ring-2 ring-blue-500 ring-opacity-50': isHovered}" @mouseenter="isHovered = true"
							@mouseleave="isHovered = false">
							<i class="fab fa-github text-2xl text-gray-700"></i>
							<a :href="githubUrl" target="_blank" rel="noopener noreferrer"
								class="font-mono text-blue-600 hover:text-blue-800 flex-1 truncate"
								@mouseenter="linkTooltipVisible = true" @mouseleave="linkTooltipVisible = false">
								{{ githubUrl }}
								<div v-if="linkTooltipVisible"
									class="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded">
									在新窗口打开
								</div>
							</a>
							<button
								class="!rounded-button whitespace-nowrap bg-white hover:bg-gray-50 text-gray-600 px-4 py-2 border border-gray-300 rounded-md flex items-center space-x-2"
								@click="copyToClipboard" @mouseenter="copyTooltipVisible = true"
								@mouseleave="copyTooltipVisible = false">
								<i class="far fa-copy"></i>
								<span>
									<!-- 复制 -->
									{{ $t('language000195') }}
								</span>
								<div v-if="copyTooltipVisible"
									class="absolute -top-8 right-0 bg-gray-800 text-white text-sm px-2 py-1 rounded">
									点击复制
								</div>
							</button>
						</div>
						<div v-if="showCopySuccess" class="mt-2 text-sm text-green-600 flex items-center">
							<i class="fas fa-check mr-1"></i>
							<span>已复制到剪贴板</span>
						</div>
					</div>

					<div class="bg-gray-50 rounded-lg border border-gray-200 p-6">
						<h2 class="text-lg font-medium text-gray-700 mb-4">iOS</h2>
						<div class="flex items-center space-x-4 bg-gray-100 rounded-lg p-4 group relative"
							:class="{'ring-2 ring-blue-500 ring-opacity-50': isHoveredIOS}"
							@mouseenter="isHoveredIOS = true" @mouseleave="isHoveredIOS = false">
							<i class="fab fa-github text-2xl text-gray-700"></i>
							<a :href="iosGithubUrl" target="_blank" rel="noopener noreferrer"
								class="font-mono text-blue-600 hover:text-blue-800 flex-1 truncate"
								@mouseenter="linkTooltipVisibleIOS = true" @mouseleave="linkTooltipVisibleIOS = false">
								{{ iosGithubUrl }}
								<div v-if="linkTooltipVisibleIOS"
									class="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded">
									在新窗口打开
								</div>
							</a>
							<button
								class="!rounded-button whitespace-nowrap bg-white hover:bg-gray-50 text-gray-600 px-4 py-2 border border-gray-300 rounded-md flex items-center space-x-2"
								@click="copyToClipboardIOS" @mouseenter="copyTooltipVisibleIOS = true"
								@mouseleave="copyTooltipVisibleIOS = false">
								<i class="far fa-copy"></i>
								<span>
									<!-- 复制 -->
									{{ $t('language000195') }}
								</span>
								<div v-if="copyTooltipVisibleIOS"
									class="absolute -top-8 right-0 bg-gray-800 text-white text-sm px-2 py-1 rounded">
									点击复制
								</div>
							</button>
						</div>
						<div v-if="showCopySuccessIOS" class="mt-2 text-sm text-green-600 flex items-center">
							<i class="fas fa-check mr-1"></i>
							<span>已复制到剪贴板</span>
						</div>
					</div>

				</div>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				githubUrl: this.$p_QIUI_API_AndroidUrl,
				iosGithubUrl: this.$p_QIUI_API_IosUrl,
				isHovered: false,
				isHoveredIOS: false,
				copyTooltipVisible: false,
				copyTooltipVisibleIOS: false,
				linkTooltipVisible: false,
				linkTooltipVisibleIOS: false,
				showCopySuccess: false,
				showCopySuccessIOS: false,
			};
		},
		methods: {
			goBack() {
				window.history.back();
			},
			async copyToClipboard000(key) {
				const input = document.createElement('input'); // 创建一个临时的输入框
				input.value = key; // 将要复制的内容赋值给输入框
				document.body.appendChild(input); // 将输入框添加到文档中
				input.select(); // 选中输入框中的文本
				input.setSelectionRange(0, 99999); // 对于移动设备
				document.execCommand('copy'); // 执行复制命令
				document.body.removeChild(input); // 移除临时输入框
				this.$message({
					message: this.$t('language000064'),
					type: 'success'
				});
			},
			async copyToClipboard() {
				try {
					await navigator.clipboard.writeText(this.githubUrl);
					this.showCopySuccess = true;
					setTimeout(() => {
						this.showCopySuccess = false;
					}, 2000);
				} catch (err) {
					console.error('Failed to copy text: ', err);
				}
			},
			async copyToClipboardIOS() {
				try {
					await navigator.clipboard.writeText(this.iosGithubUrl);
					this.showCopySuccessIOS = true;
					setTimeout(() => {
						this.showCopySuccessIOS = false;
					}, 2000);
				} catch (err) {
					console.error('Failed to copy text: ', err);
				}
			},
		},
	};
</script>

<style scoped>
	.animate-pulse {
		animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
	}

	@keyframes pulse {

		0%,
		100% {
			opacity: 1;
		}

		50% {
			opacity: 0.5;
		}
	}
</style>